// Standard library imports
import React, { useEffect, useState } from 'react';

//External library imports
import { toast } from 'react-toastify';
import { UilPen, UilTrash } from '@iconscout/react-unicons';
//Internal module imports
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { useLoader } from '../../../hooks';
import { CustomerService } from '../../../services/CustomerService';
import classes from '../../../styles/AllDevices.module.css';
import DeleteModal from '../../../components/DeleteModal/DeleteModal';
import { UserService } from '../../../services/UserService';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import { UilImport } from '@iconscout/react-unicons';
import IconComponent from '../../../components/Icon/Icon';
import { exportData } from '../../../utils/downloadHelper';
import homeClasses from '../Home.module.css';

function Users({ customerId, setCreateEditUser, setSelectedIndex }) {
    //5f44e6cc6d6f9046906c898a
    const [startLoader, stopLoader] = useLoader();
    const [users, setUsers] = useState([]);
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        userId: '',
    });

    useEffect(() => {
        fetchUsersById(customerId);
    }, []);
    const fetchUsersById = (id) => {
        CustomerService.Read(id, startLoader, handleFetchSucess, handleError, stopLoader);
    };
    const handleFetchSucess = ({ data }) => {
        let newData = data.data.users.map((item, index) => ({
            sno: index + 1,
            name: item.name,
            email: item.email,
            role: item.userRole,
            contact: item.contact ? `${item.countryCode ? item.countryCode : ''} ${item.contact}` : '--',
            action: (
                <div
                    style={{
                        display: 'flex',
                        gridColumnGap: '1vw',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div>
                        <CustomTooltip content={'Edit'}>
                            <UilPen
                                size={'1.2vw'}
                                style={{ color: 'var(--color-primary)' }}
                                onClick={() => {
                                    setCreateEditUser({ status: true, customerId: customerId, user: { ...item, customerName: data.data.name } });
                                    setSelectedIndex(1);
                                }}
                            />
                        </CustomTooltip>
                    </div>
                    <div>
                        <CustomTooltip content={'Delete'}>
                            <UilTrash size={'1.2vw'} style={{ color: 'var(--color-primary)' }} onClick={() => setDeleteModal({ status: true, userId: item._id })} />
                        </CustomTooltip>
                    </div>
                </div>
            ),
        }));
        setUsers(newData);
    };

    const handleDelete = () => {
        UserService.Delete(deleteModal.userId, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = (res) => {
        if (res) {
            toast.success('User deleted successfully!');
            setDeleteModal({ status: false, userId: '' });
            fetchUsersById(customerId);
        }
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    const downloadData = () => {
        exportData(users, 'Users', ['name', 'email', 'role', 'contact']);
    };

    return (
        <div className={classes.AllDevices}>
            <DeleteModal
                deletefunction={handleDelete}
                opendeleteModal={deleteModal.status}
                setOpenDeleteModal={(status) => setDeleteModal({ ...deleteModal, status })}
            ></DeleteModal>
            <div className={classes.Header}>
                <div>
                    <Typography content="All Users" />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={users.length} />
                        </span>
                    </div>
                </div>
                <div className={homeClasses.UserHeader}>
                    <div className={classes.Button}>
                        <button
                            className="btn-primary"
                            style={{ marginTop: '0' }}
                            onClick={() => {
                                setCreateEditUser({ status: true, customerId, user: {} });
                                setSelectedIndex(1);
                            }}
                        >
                            Create User
                        </button>
                    </div>
                    <div style={{ marginTop: '0.5vh' }} onClick={() => downloadData()}>
                        <IconComponent icon={UilImport} tooltip={'Download'} size="1.5vw" />
                    </div>
                </div>
            </div>
            <div>
                <Table head={['S.No', 'Email', 'Contact', 'Role', 'Action']} keys={['sno', 'email', 'contact', 'role', 'action']} data={users} />
            </div>
        </div>
    );
}

export default Users;
